import { vars } from '@styles/vanilla-extract/theme.css';
import { lazy } from 'react';
import React from 'react';
import styled from 'styled-components';
import { useTheme } from 'styled-components';

import { chartLabelClass } from './style.css';

import ReactApexChart from 'react-apexcharts';

export interface IBasicLineChart {
	data_name_a?: string;
	datas_a?: number[];
	categorys?: string[];
	width?: number;
	height?: number;
	date_picker?: any;
	isPositive?: boolean;
	grid?: boolean;
	yaxis?: boolean;
	format?: string;
	zoom?: boolean;
	min?: number;
	max?: number;
	axisType?: 'datetime' | 'category' | 'numeric' | undefined;
}

const CustomLineChart = ({
	data_name_a,
	datas_a,
	categorys = [],
	width,
	height,
	date_picker,
	isPositive,
	grid,
	yaxis,
	format,
	zoom,
	min,
	max,
	axisType = 'datetime',
}: IBasicLineChart) => {
	const reach_medias_data = [];
	let best_media_count = 1;
	const theme = useTheme();

	best_media_count = best_media_count * 4;

	return (
		<ChartContainer width={width}>
			<ReactApexChart
				options={{
					chart: {
						type: 'area',
						stacked: false,
						toolbar: {
							show: false,
						},
						zoom: { enabled: zoom ?? true },
					},
					dataLabels: {
						enabled: false,
					},
					grid: { show: grid ?? true, position: 'front' },
					stroke: {
						curve: 'straight',
					},
					colors: [
						isPositive ? vars.global.colors.primary[60] : vars.global.colors.gray[80],
					],
					fill: {
						type: 'gradient',
						colors: [
							isPositive ? vars.global.colors.primary[10] : vars.global.colors.gray[20],
						],
						gradient: {
							shade: 'dark',
							type: 'vertical',
							shadeIntensity: 1,
							gradientToColors: [
								isPositive ? vars.global.colors.primary[10] : vars.global.colors.gray[20],
							],
							inverseColors: true,
							opacityFrom: 1,
							opacityTo: 1,
							stops: [0, 50, 100],
							colorStops: [],
						},
					},
					labels: categorys ?? [],
					xaxis: {
						type: axisType,
						labels: {
							show: true,
							format: format ?? 'yyyy-MM-dd',
							style: {
								cssClass: chartLabelClass,
							},
						},
					},
					yaxis: [
						{
							opposite: true,
							labels: {
								show: yaxis ?? true,
								style: {
									cssClass: chartLabelClass,
								},
								formatter: (value) => value.toLocaleString(),
							},

							min: min && min,
							max: max && max,
						},
					],
					tooltip: {
						x: {
							format: 'yyyy-MM-dd',
						},
					},
				}}
				series={[
					{
						name: data_name_a ?? '',
						data: datas_a ?? [],
						type: 'area',
					},
				]}
				type="area"
				width={width ? `${width + 4}px` : '100%'}
				height={height ? `${height}px` : '100%'}
			/>
		</ChartContainer>
	);
};

const ChartContainer = styled.div<{ width?: number }>`
	.apexcharts-toolbar {
		z-index: 0;
	}

	width: ${({ width }) => (width ? `${width}px` : 'auto')};
	/* overflow: hidden; */
	${({ theme }) => theme.common.flexCenter}
`;

export default CustomLineChart;
